var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShareIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.01434 9.08925C5.69413 8.51409 5.08 8.125 4.375 8.125C3.33947 8.125 2.5 8.96447 2.5 10C2.5 11.0355 3.33947 11.875 4.375 11.875C5.08 11.875 5.69413 11.4859 6.01434 10.9107M6.01434 9.08925C6.16447 9.35891 6.25 9.66947 6.25 10C6.25 10.3305 6.16447 10.6411 6.01434 10.9107M6.01434 9.08925L13.9857 4.66075M6.01434 10.9107L13.9857 15.3393M13.9857 15.3393C13.8355 15.6089 13.75 15.9195 13.75 16.25C13.75 17.2855 14.5895 18.125 15.625 18.125C16.6605 18.125 17.5 17.2855 17.5 16.25C17.5 15.2145 16.6605 14.375 15.625 14.375C14.92 14.375 14.3059 14.7641 13.9857 15.3393ZM13.9857 4.66075C14.3059 5.23591 14.92 5.625 15.625 5.625C16.6605 5.625 17.5 4.78553 17.5 3.75C17.5 2.71447 16.6605 1.875 15.625 1.875C14.5895 1.875 13.75 2.71447 13.75 3.75C13.75 4.08053 13.8355 4.39109 13.9857 4.66075Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon);
export default __webpack_public_path__ + "static/media/ShareIcon.8ee0a532b8cce306738dc2d4241a6fc3.svg";
export { ForwardRef as ReactComponent };